import { render, staticRenderFns } from "./AgentProfilePopupInfo.vue?vue&type=template&id=bcae683c&scoped=true"
import script from "./AgentProfilePopupInfo.vue?vue&type=script&lang=ts"
export * from "./AgentProfilePopupInfo.vue?vue&type=script&lang=ts"
import style0 from "./AgentProfilePopupInfo.vue?vue&type=style&index=0&id=bcae683c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.34_css-loader@7.1.4_webpack@5.106.2__ejs@3.1.1_13e7c134e45fa6702d5864e7d90f41d2/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bcae683c",
  null
  
)

export default component.exports